import * as angular from 'angular';
import template from "./kpi.tpl.html";

export default angular
    .module('aps.directives.kpi', [])
    .directive('kpi', () => {
        return {
            replace: true,
            scope: {
                kpis: '=kpis'
            },
            template: template
        };
    })
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/kpi.directive.ts